<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>

    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">

        <img class="user-avatar" :src="avatar">
        <span style="position: relative;top:-10px;"> {{$store.getters.name}}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown @command="handleMessage" trigger="click" class="avatar-container" style="right:130px">
      <span class="el-dropdown-link tellmessage">
          <i class="el-icon-bell" style="font-size:18px;"></i>
      <el-badge :value="$store.getters.messageDataObj.total" :max="99" class="item "
                style=" margin-top: 10px;height:62px;" >系统通知</el-badge>
      </span>
      <el-dropdown-menu slot="dropdown">
       <el-dropdown-item  command="untreatedCount">1、退货申请_待处理
          ({{ $store.getters.messageDataObj["untreatedCount"] ? $store.getters.messageDataObj["untreatedCount"] : 0 }})
        </el-dropdown-item>
        <el-dropdown-item  command="returnCount">2、退货申请_退货中
          ({{ $store.getters.messageDataObj["returnCount"] ? $store.getters.messageDataObj["returnCount"] : 0 }})
        </el-dropdown-item>
        <el-dropdown-item  command="refundcount">3、财务_退款审核
          ({{ $store.getters.messageDataObj["refundCount"] ? $store.getters.messageDataObj["refundCount"] : 0 }})
        </el-dropdown-item>
        <el-dropdown-item  command="notSendCount">4、待发货订单
          ({{ $store.getters.messageDataObj["notSendCount"] ? $store.getters.messageDataObj["notSendCount"] : 0 }})
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>

</template>

<script>
import {mapGetters} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  methods: {
    handleMessage(status) {


      if (status === 'untreatedCount' || status === 'returnCount') {
        this.$router.push({path: '/oms/returnApply', query: {messageStatus: status}}).catch((err) => {})
      }

      if (status === 'refundcount') {
        this.$router.push({path: '/finance/RefundReview', query: {messageStatus: status}}).catch((err) => {})
      }

      if (status === 'notSendCount') {
        this.$router.push({path: '/oms/order', query: {status: 1}}).catch((err) => {})
      }
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
.tellmessage:hover{
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue